"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _getDeviceName = require("../../helpers/get-device-name");

var _const = require("../../const");

var _helpers = require("../../helpers");

var _carouselUi = _interopRequireDefault(require("../carousel/carousel-ui"));

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _lazyLoadImage = require("../lazy-load-image");

var _headerTitles = require("../header-titles");

var _const2 = require("./const");

var _photoLinks = require("./photo-links.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PhotoLinks = function PhotoLinks(props) {
  var headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      type = props.type,
      _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _const2.PhotoLinksTheme.WHITE : _props$theme,
      _props$images = props.images,
      images = _props$images === void 0 ? [] : _props$images,
      gridLinksNumber = props.gridLinksNumber,
      carouselLinksNumber = props.carouselLinksNumber,
      imageRatio = props.imageRatio,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding,
      _props$buttons = props.buttons,
      buttons = _props$buttons === void 0 ? [] : _props$buttons;

  if (!headline1 && !headline2 && !description && !images.length) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure PHOTO LINKS component");
  }

  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      themeType = _themeStrategy$curren.type;
  var isDarkTheme = themeType === _themeOptions.ThemeType.DARK;
  var arrowColor = isDarkTheme ? 'light' : 'dark';

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      backDropOffset = _useState2[0],
      setBackDropOffset = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      backDropSize = _useState4[0],
      setBackDropSize = _useState4[1];

  var deviceName = (0, _getDeviceName.getDeviceName)();
  var theme = {
    $theme: currentTheme,
    $type: type,
    $backDropOffset: backDropOffset,
    $backDropSize: backDropSize
  };
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var bottomPadding = removeBottomPadding ? 0 : paddingSize;
  var topPadding = removeTopPadding ? 0 : paddingSize;
  var containerPadding = [topPadding, 0, bottomPadding];
  var containerRef = (0, _react.useRef)(null);

  var gridView = function gridView() {
    var height = _const2.gridImageSizeStrategy[[deviceName, gridLinksNumber, imageRatio]].height;

    var updateBackDrop = function updateBackDrop() {
      if (containerRef) {
        var _containerRef$current = containerRef.current,
            gridTop = _containerRef$current.offsetTop,
            gridHeight = _containerRef$current.offsetHeight;
        var topOffset = gridTop + height / 2;

        var _backDropSize = gridHeight - height / 2 * 2 - 30;

        setBackDropOffset(topOffset);
        setBackDropSize(_backDropSize);
      }
    };

    return /*#__PURE__*/_react.default.createElement(_photoLinks.PhotoLinksGridStyled, {
      onLoad: updateBackDrop,
      ref: containerRef,
      columnNumber: gridLinksNumber
    }, images.map(function (_ref, index) {
      var fileReference = _ref.fileReference,
          link = _ref.link,
          linkTitle = _ref.linkTitle,
          altText = _ref.altText;
      return /*#__PURE__*/_react.default.createElement(_photoLinks.PhotoLinksItemStyled, {
        href: link,
        key: "".concat(linkTitle, "-").concat(index),
        isDarkTheme: isDarkTheme,
        height: height
      }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
        src: fileReference,
        placeholderSrc: fileReference,
        alt: altText,
        height: height
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        as: "span",
        display: "block",
        mt: 15,
        measure: "xxs",
        lineHeight: 15,
        letterSpacing: 1.65,
        color: headline2Color,
        uppercase: true,
        fontWeight: "bold"
      }, linkTitle));
    }));
  };

  var carouselView = function carouselView() {
    var _carouselImageSizeStr = _const2.carouselImageSizeStrategy[[deviceName, carouselLinksNumber, imageRatio]],
        height = _carouselImageSizeStr.height,
        slidesToShow = _carouselImageSizeStr.slides;
    var infinite = images.length >= slidesToShow;

    var updateBackDrop = function updateBackDrop() {
      if (containerRef) {
        var carouselTop = containerRef.current.offsetTop;

        var _backDropSize2 = carouselTop + height - height / 3;

        setBackDropOffset(0);
        setBackDropSize(_backDropSize2);
      }
    };

    return /*#__PURE__*/_react.default.createElement(_photoLinks.CarouselWrapper, {
      onLoad: updateBackDrop,
      ref: containerRef
    }, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
      arrowStyle: "flat",
      arrowColor: arrowColor,
      settings: _objectSpread(_objectSpread({}, _const2.settings), {}, {
        slidesToShow: slidesToShow,
        infinite: infinite
      })
    }, images.map(function (_ref2, index) {
      var fileReference = _ref2.fileReference,
          link = _ref2.link,
          linkTitle = _ref2.linkTitle,
          altText = _ref2.altText;
      return /*#__PURE__*/_react.default.createElement(_photoLinks.PhotoLinksItemStyled, {
        href: link,
        key: "".concat(linkTitle, "-").concat(index),
        isDarkTheme: isDarkTheme,
        height: height
      }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
        src: fileReference,
        placeholderSrc: fileReference,
        alt: altText,
        height: height,
        skipLazy: true
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        as: "span",
        display: "block",
        mt: 15,
        measure: "xxs",
        lineHeight: 15,
        letterSpacing: 1.65,
        color: headline2Color,
        uppercase: true,
        fontWeight: "bold"
      }, linkTitle));
    })));
  };

  var view = type === _const2.PhotoLinksView.CAROUSEL ? carouselView() : gridView();
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_photoLinks.StyledBox, {
    p: containerPadding,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_PHOTO_LINKS
  }, /*#__PURE__*/_react.default.createElement(_photoLinks.ContainerStyled, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    noGutters: true
  }), !!images.length && view, !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    mt: 45,
    buttons: buttons,
    color: (0, _helpers.getButtonColorByTheme)(isDarkTheme)
  }))));
};

var _default = PhotoLinks;
exports.default = _default;